import { PointData } from 'pixi.js';
import { BehaviorSubject } from 'rxjs';
import { Account } from './account';
import { Room } from './room';
import { C, IRoomSettings, L } from './_api';
import { RoomSprite } from 'src/graphics/room-sprite';
import { Util } from 'src/util/util';

export class Store {
    private static rollSfx = new Audio('./assets/roll.mp3');
    private static music = new Audio('./assets/music.mp4');
    private static music2 = new Audio('./assets/music2.mp4');
    private static evil = new Audio('./assets/evil.mp4');
    public static victory = new Audio('./assets/victory_out.mp3');

    /* Data */
    public static imageUploadUrl: string;
    public static imageUpload: HTMLImageElement;
    public static chatmode: C = C.All;

    /* Events */
    public static connection = new BehaviorSubject<boolean>(true);
    public static mode = new BehaviorSubject<'scrawl' | 'play'>('play');
    public static mouse = new BehaviorSubject<{ point: PointData }>({ point: { x: 0, y: 0 } });
    public static isReferee = new BehaviorSubject(false);
    public static isLiberated = new BehaviorSubject(false);
    public static fullAccess = new BehaviorSubject(false);
    public static isMobile = new BehaviorSubject(false);
    public static activeSprite = new BehaviorSubject<RoomSprite | undefined>(undefined);
    public static multiselect = new BehaviorSubject<RoomSprite[] | undefined>(undefined);

    public static initialize() {
        Room.tokens.watchAll(() => {
            const activeId = Store.activeSprite.value?.data.id;
            if (activeId) {
                const token = Room.tokens.get(activeId);
                if (token == null || Util.isEmpty(token)) {
                    Store.activeSprite.next(undefined);
                }
            }
        });

        // TODO: create a NextIfChanged method
        Room.settings.watch((settings) => this.update(settings));
        Room.attendance.watch((id) => {
            if (Account.id == id) this.update(Room.settings.get())
        });
        Store.detectMobile();
        window.addEventListener('resize', Store.detectMobile);
    }

    public static update(settings: IRoomSettings) {
        const attendee = Room.attendance.get(Account.id);
        Store.isReferee.next(attendee.referee ?? false);

        const fullAccess = attendee.referee || settings.freedom == true;
        if (Store.isLiberated.value != settings.freedom) {
            Store.isLiberated.next(settings.freedom);
        }

        if (Store.fullAccess.value != fullAccess) {
            Store.fullAccess.next(fullAccess);
            if (fullAccess == false) {
                Account.settings.modify(x => {
                    x.activeLayerId = L.Tokens;
                    x.snapping = false;
                    x.alignment = 1;
                });
            }
        }
    }

    public static playMusic(music: string) {
        Store.music.pause();
        Store.music.currentTime = 0;
        Store.music2.pause();
        Store.music2.currentTime = 0;
        Store.evil.pause();
        Store.evil.currentTime = 0;

        if (music == 'music1') {
            Store.music.play();
            Store.music.loop = true;
        } else if (music == 'music2') {
            Store.music2.play();
            Store.music2.loop = true;
        } else if (music == 'evil') {
            Store.evil.volume = 0.3;
            Store.evil.play();
            Store.evil.loop = true;
        }
    }

    public static playDicerollSFX() {
        if (Account.settings.get().disableSFX === true) return;

        Store.rollSfx.pause();
        Store.rollSfx.currentTime = 0;
        Store.rollSfx.play();
    }

    public static detectMobile() {
        if (window.innerWidth < 900 && Store.isMobile.value == false) {
            Store.isMobile.next(true);
        } else if (window.innerWidth >= 900 && Store.isMobile.value == true) {
            Store.isMobile.next(false);
        }
    }
}
